const getWindowConfig = () => {
    if (typeof window === 'undefined') {
        return {};
    }

    return window.__TRACKER_CONFIG__ || {};
};

const getEnvFallback = () => process.env.REACT_APP_API_PATH || '';

// Deploy substitutes the runtime-config.js placeholder by scanning main.*.js
// for the same literal text, so the full placeholder token ('{APP_API_PATH}')
// can't be used here as an "unconfigured" sentinel -- that exact string
// itself gets rewritten wherever it appears in the compiled bundle. Every
// placeholder in this deploy scheme uses the '{NAME}' convention, so
// checking only the leading brace avoids embedding the corruptible literal
// while still rejecting an unresolved value, whatever its real form (an
// absolute URL or a same-origin relative path) is once substituted. A value
// starting with '$(' is ADO's unexpanded macro, which the deploy writes when
// the variable group lacks the value.
const isUnresolvedPlaceholder = (value) => typeof value !== 'string' || value === '' || value.startsWith('{') || value.startsWith('$(');

export const getApiPath = () => {
    const runtimeValue = getWindowConfig().REACT_APP_API_PATH;

    if (!isUnresolvedPlaceholder(runtimeValue)) {
        return runtimeValue;
    }

    return getEnvFallback();
};

export const getRecaptchaSiteKey = () => {
    const runtimeValue = getWindowConfig().REACT_APP_RECAPTCHA_SITE_KEY;

    if (!isUnresolvedPlaceholder(runtimeValue)) {
        return runtimeValue;
    }

    const envValue = process.env.REACT_APP_RECAPTCHA_SITE_KEY;

    return isUnresolvedPlaceholder(envValue) ? null : envValue;
};
